import fetch from 'isomorphic-fetch'
import { authHeader, handleResponse } from './helpers'
import { API_URL } from '../../constants/Config'

export const settingsService = {
  getSetting,
  updateSetting,
  getCowriterInstructions,
  updateCowriterInstructions,
}

async function getSetting(auth_token, name, product) {
  const url = `${API_URL}/settings/${name}?${product ? 'product=' + product : ''}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options)
    .then(response => handleResponse(response))
    .then(response => response.value)
}

async function updateSetting(auth_token, name, value, product, notify) {
  const url = `${API_URL}/settings/${name}?${product ? 'product=' + product + '&' : ''}${
    notify ? 'notify=true' : ''
  }`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ value: value }),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function getCowriterInstructions(auth_token) {
  const url = `${API_URL}/settings/cowriter_instructions`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
  }
  return fetch(url, options)
    .then(response => handleResponse(response))
    .then(response => response.value)
}

async function updateCowriterInstructions(auth_token, instructions) {
  const url = `${API_URL}/settings/cowriter_instructions`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      value: instructions
    }),
  }
  return fetch(url, options).then(response => handleResponse(response))
}
